var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-sp-services"},[_c('div',{staticClass:"company-sp-services-title"},[_vm._v(" "+_vm._s(_vm.$t('sp.registration.company.services.title'))+" ")]),_c('company-s-p-services-form',{attrs:{"value":_vm.spCompanyServicesInfo},on:{"changed":_vm.formChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }